// extracted by mini-css-extract-plugin
export default {"pastDue35":"reports_pastDue35__7i6eb","tbody":"reports_tbody__gKOuX","pastDue25":"reports_pastDue25__2NXWu","pastDue15":"reports_pastDue15__m94wz"};